import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BasicActionsEventType } from '../DatatableEvents/basic-actions-event-type';
import { SubscriptionActionsComponent } from '../DatatableEvents/subscription-actions.component';
class DataTablesResponse {
  data: any[];
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  @ViewChild('subscriptionActions') subscriptionActions: TemplateRef<SubscriptionActionsComponent>;
  //dtOptions: DataTables.Settings = {};
  dtOptions: ADTSettings = {};
  message = '';
  modalid="newsubscription"
  modalid1="subscriptioncancel"
  deleteid=""
  constructor(public adminApi: AdminapiService){


  }

  
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      $('table.dataTable').DataTable().clearPipeline().draw();
      //dtInstance.clearPipeline().draw()
      //dtInstance.clear().draw();
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  changeData(event){
    this.rerender()
  }

  ngOnInit(): void {
    setTimeout(() => {
      const self = this;
      this.dtOptions = {
        language: {
          searchPlaceholder: "Search user, subscription id, description...",
          // search: "Search:",
        },
        serverSide: true,  
        ordering:false,
        processing: true,
        lengthMenu:['10','20','30','40','50'],
        //order: [[0, 'desc']],
        //columnDefs: [{ targets: 3, orderable: false }],
        pageLength: 50,   // Set the flag 
        ajax: this.adminApi.getSubscriptions(),
        columnDefs: [
          { 'width': '40px', 'targets': 0 },
          { 'width': '250px', 'targets': 3 },
          { 'width': '80px', 'targets': -1 },
          { 'width': '130px', 'targets': -2 },
        ],
        columns: [{
          title: 'ID',
          data: 'id'
        }, {
          title: 'Subscription Id',
          data: 'subscription_id'
        },{
          title: 'User',
          data: 'username'
        }, {
          title: 'Description',
          data: 'description'
        }, {
          title: 'Amount',
          data: 'amount'
        },{
          title: 'Status',
          data: 'subscription_status_btn'
        },{
          title: 'Dates',
          data: 'trial_ends'
        },
        {
          title: 'Actions',
          data: null,
          ngTemplateRef: {
            ref: this.subscriptionActions,
            context: {
              // needed for capturing events inside <ng-template>
              captureEvents: self.onCaptureEvent.bind(self),
            }
          }
        
        }
      ]
      };
    });
  }

  onCaptureEvent(event: BasicActionsEventType) {
    //this.message = `Event '${event.cmd}' with data '${JSON.stringify(event.data)}`;
    if(event.cmd=='cancel'){
      this.deleteid = event.data.id;
      this.openConfirmModal()
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      this.dtTrigger.next(this.dtOptions);
    }, 200);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  addNewModal() {
    this.openModal()
  }

  openModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  openConfirmModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid1)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid1), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }
}
